import { Markdown } from '@cadstrom/sigma-engine-shared';

import { BasicRemarkPlugin } from './markdown-plugins-utils.js';
import { SignalMarkdownItem } from './signal-reference-markdown-item.js';

import type { RemarkMarkdownDirectiveDefinition } from './markdown-plugins-utils.js';

/**
 * Remark plugin definition for signal reference directives (`:signal[SCL]`).
 * Display-only: signal references have no shorthand marker and no editor plugin.
 */
export const signalMarkdownItemDefinition: RemarkMarkdownDirectiveDefinition<
	typeof Markdown.SignalReferenceMarkdownDirectiveDefinition
> = {
	allowedAttributes: Markdown.SignalReferenceMarkdownDirectiveDefinition.allowedAttributes,
	directive: BasicRemarkPlugin(
		Markdown.SignalReferenceMarkdownDirectiveDefinition.directive,
		Markdown.NodeTypes.AllDirectives,
		{ contentPropName: Markdown.SignalReferenceMarkdownDirectiveDefinition.contentAttributeName },
	),
	item: SignalMarkdownItem,
};
